import { API, DOMAIN } from '@autopass-web/domain';
import HttpClient from '../http-client';

class MochiUserHttpClient extends HttpClient {
  constructor(props: any) {
    super(props);
    this.apiConfig = DOMAIN.API_URL[API.MOCHI_USER];
    this.httpClient = this.createHttpClient({
      headers: this.apiConfig.headers,
      baseUrl: this.apiConfig.baseUrl,
    });

    this.httpClient.interceptors.request.use((value: any) =>
      this.interceptRequest(value),
    );
    this.httpClient.interceptors.response.use(
      (value: any) => this.interceptResponseResult(value),
      (error: any) => this.interceptResponseError(error, this.httpClient),
    );
  }

  fetchGasStations = () =>
    this.get('/pois', {
      cooperation_states: 'in_cooperated,coming_soon',
      store_types: 'GasStation',
    });

  fetchParkinglots = () =>
    this.get('/pois', {
      cooperation_states: 'in_cooperated,coming_soon',
      store_types: 'Parkinglot',
    });

  fetchChainStores = ({ transactionTypes }: { transactionTypes: string }) =>
    this.get('/pois', {
      cooperation_states: 'in_cooperated',
      transaction_types: transactionTypes,
      store_types: 'ChainStore',
    });
}

export default MochiUserHttpClient;
